export const role = [
  { Type: "ADMIN" },
  { Type: "REGISTRAR" },
  { Type: "ARBITRATOR" },
  { Type: "USER" },
];

// Where a user lands after login / on "/". Arbitrators have no Dashboard.
export const homePathFor = (roles) => (/^arbitrator$/i.test(roles || "") ? "/cases" : "/dashboard");
